// Added by Sejune Oh on 2019-03-22
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { Component } from 'react'
import { observer } from 'mobx-react'
import { observable, action, makeObservable } from 'mobx'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Define
import { ReactInputChangeEvent, ReactClickEvent, ReactKeyUpEvent } from '@/helper/define'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Components
import PasswordInput, { PasswordInputFieldBaseFCProps } from './PasswordInput'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
interface PasswordInputCProps extends PasswordInputFieldBaseFCProps {
  onInputKeyUp?: ReactKeyUpEvent
  onChange?: Function
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
@observer
class PasswordInputFieldContainer extends Component<PasswordInputCProps> {
  isTypePassword: boolean = true

  constructor(props: PasswordInputCProps) {
    super(props)
    makeObservable(this, {
      isTypePassword: observable,
      handleClick: action,
    })
  }

  render() {
    const { onInputKeyUp, ...other } = this.props

    return (
      <PasswordInput
        {...other}
        isTypePassword={this.isTypePassword}
        onChange={this.handleChange}
        onClick={this.handleClick}
        onInputKeyUp={onInputKeyUp}
        data-cy-input-wrapper={other.id}
      />
    )
  }

  handleChange: ReactInputChangeEvent = (event) => {
    if (this.props.onChange) {
      this.props.onChange(event)
    } else {
      // TODO PasswordInput에서 직접 PW를 받아서 사용하는 경우.
    }
  }

  handleClick: ReactClickEvent = () => {
    this.isTypePassword = !this.isTypePassword
  }
}

export default PasswordInputFieldContainer
